export default "__VITE_ASSET__CTli9bXH__"